// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import HighlightedText from '../../../../components/HighlightedText';
import BoardListItem from '../../../../components/popupPanel/listItems/BoardListItem';
import ListItemBoardIcon from '../../../../components/popupPanel/listItems/ListItemBoardIcon';

// Utils
import branchSingular from '../../../../../common/utils/lib/branchSingular';
import platformSingleton from '../../../../platform/platformSingleton';

// Styles
import './ElementSearchResultBoard.scss';

const pluralMatch = branchSingular('match', 'matches');

const SearchResultBoard = ({
    currentBoardId,
    board,
    resultsCount,
    linkUrl,
    searchQuery,
    gridSize,
    setFocusIndex,
    focusOnInput,
    index,
    isCurrentBoardResult,
}) => {
    const title = board && board.getIn(['content', 'title']);

    const suffix = isCurrentBoardResult ? ' in your current board' : '';

    return (
        <BoardListItem
            className={classNames('ElementSearchResultBoard', { current: isCurrentBoardResult })}
            figure={<ListItemBoardIcon gridSize={gridSize} element={board} />}
            gridSize={gridSize}
            linkUrl={linkUrl}
            onClick={() => {
                setFocusIndex && setFocusIndex(index);

                if (!platformSingleton.features.isTouch && focusOnInput) {
                    focusOnInput();
                }
            }}
            board={board}
            active
        >
            <div className="message">
                <HighlightedText className="title" highlightText={searchQuery} text={title} />
                <div className="results">
                    {resultsCount ? `${resultsCount} ${pluralMatch(resultsCount)}${suffix}` : null}
                </div>
            </div>
        </BoardListItem>
    );
};

SearchResultBoard.propTypes = {
    currentBoardId: PropTypes.string,
    board: PropTypes.object,
    searchQuery: PropTypes.string,
    linkUrl: PropTypes.string,
    resultsCount: PropTypes.number,
    gridSize: PropTypes.number,

    setFocusIndex: PropTypes.func,
    focusOnInput: PropTypes.func,
    index: PropTypes.number,

    isCurrentBoardResult: PropTypes.bool,
};

export default SearchResultBoard;
